import { createRouter, createWebHashHistory } from "vue-router";
import { getCurrentInstance } from "vue";
import { ElMessage } from "element-plus";
import Login from "../views/login.vue";
import Home from "@/views/home.vue";
const routes = [
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
    {
    path: "/404",
    name: "404",
    component: () => import('@/views/404/404.vue'),
  },
  {
    path: "/",
    name: "Home",
    component: Home,
    redirect: "/login",
    children: [
      {
        path: "/account",
        name: "Account",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/account/account.vue"
          ),
      },
    ],
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});
router.beforeEach((to, from, next) => {
  if (to.path === '/404') {
    next()
    return
  }
  const info = sessionStorage.getItem("loginInfo");
  if (!info && to.name !== "Login") {
    ElMessage(
      {
        type: "warning",
        message: "Please log in to your account first",
      },
      getCurrentInstance()
    );
    const projectInfo = JSON.parse(sessionStorage.getItem("projectInfo")) || {};
    router.push({ name: "Login", query: projectInfo });
  } else {
    next();
  }
});
export default router;
